import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { External } from '../../decorators/app.decorators';
import { SILENT_REQUEST } from '../../interceptors/silent-request.token';
import { EnvironmentService } from '../environment.service';
import { FeatureFlag } from '../../data-models/feature-flag.model';

/**
 * SILENT_REQUEST: flags are fetched on every app load, so without it the global
 * ErrorHandlerInterceptor would raise an alert on every page load while the
 * data provider is down. It would also turn 403/404/503 into EMPTY, which skips
 * FeatureFlagsState's catchError and leaves whatever flags were cached in place,
 * even a previous user's. Silent requests rethrow instead. A 401 still logs the
 * user out: that check runs first.
 */
const silent = { context: new HttpContext().set(SILENT_REQUEST, true) };

@External()
@Injectable({
  providedIn: 'root'
})
export class FeatureFlagApiService {
  constructor(private http: HttpClient, private envService: EnvironmentService) {}

  getFeatureFlags(): Observable<FeatureFlag[]> {
    return this.http.get<FeatureFlag[]>(`${this.envService.config?.dataProviderAPIUrl}user/feature-flags`, silent);
  }
}
